import {IHttpResponse, IHttpService, IPromise} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {Branch} from "../../branches/model/Branch";

export class BranchesService {

    private $http: IHttpService;

    public static instance = ['$http', BranchesService];

    constructor($http: IHttpService) {
        this.$http = $http;
    }

    save(branch : Branch) : angular.IHttpPromise<unknown> {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/branches'),
            data: branch
        });
    }

    getAllBranches = (): IPromise<IHttpResponse<Branch[]>> => this.$http({
        method: 'GET',
        url: getAbsoluteUrl('api/branches')
    });

    changeBranchBrand = (brandName: string,
                         branch: Branch) => this.$http({
        method: 'PUT',
        url: getAbsoluteUrl(`api/branches/${branch.branchName}`),
        params: {
            brand_name: brandName,
            update_brand: true
        }
    });

    getAutocompleteBranches = (): IPromise<IHttpResponse<Branch[]>> => this.$http({
        method: "GET",
        url: getAbsoluteUrl('api/branches'),
        params: {
            'format_autocomplete': true
        }
    });

    deleteBranch = (branch: Branch) => this.$http({
        method : 'DELETE',
        url: getAbsoluteUrl('api/branches'),
        data: branch
    })
}
